import Vue from 'vue'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

import {
  Dialog,
  Input,
  InputNumber,
  Select,
  Button,
  ButtonGroup,
  DatePicker,
  Form,
  FormItem,
  Icon,
  Upload,
  Loading,
  Notification,
  Option,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  Image,
  Slider,
  TimePicker
} from 'element-ui'

Vue.use(Dialog)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(Image)
Vue.use(Slider)
Vue.use(TimePicker)

Vue.prototype.$notify = Notification
